module.exports = __webpack_public_path__ + "4b85b396534052790dbbf543107bf0f7.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/team/lisa.png
// module id = 649
// module chunks = 0